export enum routePath {
  NONE = '',
  DASHBOARD = 'dashboard',
  OFFERING = 'offering',
  TICKET = 'ticket',
  LOCATION = 'location',
  PROPERTY_MANAGEMENT = 'propertymanagement',
  SELF_SERVICE = 'selfservice',
  PROFILE = 'profile',
  FEEDBACK = 'feedback',
  AUTHENTICATION = 'authentication',
  TASKS = 'taskmodule',
  INFO = 'info',
  ADMIN = 'admin',
  PERMISSION_REQUEST = 'permission-request',
  STANDORTPROGNOSE = 'standortprognose',
  SOP = 'sop',
}
